import GiftCardBrand from './GiftCardBrand';

export default GiftCardBrand;
